export default "__VITE_ASSET__rX2rrzVM__"